import React from 'react'

export const handleEnterKeyPress = <T>(
  e: React.KeyboardEvent<HTMLElement>,
  callback: (...args: T[]) => void,
) => {
  if (e.key === 'Enter') {
    callback()
  }
}
